import { MatDialogConfig } from "@angular/material/dialog";
import { AgeVerificationData } from "../../../../interfaces/src/lib/age-verification.interface";

export function getAgeVerificationDialogConfig() {
    const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        dialogConfig.width = '450px';
        dialogConfig.minHeight = '200px';
        dialogConfig.maxHeight = '90vh';
        dialogConfig.panelClass = [
          'rounded-dialog',
          'fullscreen-dialog',
          'ordering-dialog',
        ];
    
    dialogConfig.data = {
        title: 'Age Verification',
        message: 'Please confirm that you are over 18 years old.',
        cancelText: 'I am under 18',
        confirmText: 'I am over 18',
    } as AgeVerificationData;

    return dialogConfig;
}